import Popin from './popin';

export default secretaries => {
    // console.log('secretaries');

    for (const card of secretaries.querySelectorAll('.card.secretary')) {
        card.addEventListener('click', () => {
            new Popin({
                id: card.dataset.popin,
                beforeOpen() {
                },
                afterClose() {
                },
            });
        });
    }
};
